import { Component, inject } from '@angular/core';
import { ThemeService } from '@libs/vc-core-lib';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

declare module 'highcharts' {
    interface Point {
        custom?: {
            value: never; // Custom value for handling rendering
        };
    }
}

@Component({
    selector: 'vc-core-app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet],
})
export class AppComponent {
    private readonly _themeService: ThemeService = inject(ThemeService);

    private readonly _matIconRegistry: MatIconRegistry = inject(MatIconRegistry);
    private readonly _domSanitizer: DomSanitizer = inject(DomSanitizer);

    constructor() {
        this._addIcons();
        this._themeService.getThemeAndSet();
    }

    private _addIcons() {
        this._matIconRegistry
            .addSvgIcon(
                'vc-logo',
                this._domSanitizer.bypassSecurityTrustResourceUrl('assets/images/logo/asgard-platform-logo.svg')
            )
            .addSvgIcon(
                'windows-symbol',
                this._domSanitizer.bypassSecurityTrustResourceUrl('assets/images/windows_symbol.svg')
            )
            .addSvgIcon('logo-linux', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/images/logo_linux.svg'))
            .addSvgIcon('logo-mac', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/images/logo_mac.svg'));
    }
}
